<section id="occupational-profile-base-info" class="o-wrapper">
	@if (config) {
	<div class="c-header-profession">
		<div class="c-header-profession__content">
			<a [href]="config.beroepenlijstUrl" class="o-routing-link -back-on-hover">Alle beroepen</a>

			<h1 id="occupational-profile-base-info-title" class="c-intro-block__title">
				{{ occupationalProfile.title?.nl }}
				@if (occupationalProfile.vdabSpecific.bottleneckJob) {
					<span id="occupational-profile-bottleneck-job" class="c-tag -success -light">knelpuntberoep</span>
				}
				{{ ' ' }}
				@if (occupationalProfile.vdabSpecific.hasAttribute('GEREGLEMENTEERDBEROEP')) {
					<span id="occupational-profile-gereglementeerd-beroep" class="c-tag -info -light">Gereglementeerd beroep</span>
				}
			</h1>
			<p id="occupational-profile-base-info-domain"  class="c-header-profession__meta">
				{{ (occupationalProfile.hasMultipleDomains() ? "Jobdomeinen: " : "Jobdomein: ") + occupationalProfile.getInfoDomains() }}
			</p>
		</div>

		<div class="c-header-profession__buttons c-btn-group">
			<a href="/prive/webapps/mijnberoepen?beroepId={{occupationalProfile.id}}"
			   class="c-btn -secundary icon-plus -small">
				Voeg toe aan mijn beroepen
			</a>
			@if (config.voegVaardighedenToeUrl) {
			<a href="{{config.voegVaardighedenToeUrl}}{{occupationalProfile.id}}" class="c-btn -secundary icon-plus -small" id="voegVaardighedenToeLink">
				Voeg vaardigheden van dit beroep toe aan mijn profiel
			</a>
			}
		</div>
	</div>
	}
</section>

<section class="o-wrapper">
	<div [ngClass]="getPhoto() ? 'o-2-col' : 'o-2-col -sidearea'">
		<div class="c-intro-profession">
			<p id="occupational-profile-base-info-description" class="c-intro-profession__text">
				{{ occupationalProfile.description?.nl }}
			</p>
			<navigation-info [occupationalProfile]="occupationalProfile"></navigation-info>
		</div>
		@let computerPhoto = getComputerPhoto();
		@if (computerPhoto) {
			<div class="c-image-box u-hide@tablet">
				@if (showComputer) {
					<img (error)="hideImageAndFooterComputer()" id="occupational-profile-computer-photo"
						 class="c-image-box__image" [src]="getSanitizedUrl(computerPhoto)" alt="">
					<footer class="c-image-box__copyright"><small>© Shutterstock of VDAB</small></footer>
				}
			</div>
		}
		@let tabletPhoto = getTabletPhoto();
		@if (tabletPhoto) {
			<div class="c-image-box u-show@tablet">
				@if (showTablet) {
					<img (error)="hideImageAndFooterTablet()" id="occupational-profile-tablet-photo"
						 class="c-image-box__image" [src]="getSanitizedUrl(tabletPhoto)" alt="">
					<footer class="c-image-box__copyright"><small>© Shutterstock of VDAB</small></footer>
				}
			</div>
		}
	</div>
</section>
